import { z } from 'zod';

// GET /app_service/panel/v1/me as app-service answers it (CBX-11638). Unknown keys are stripped, so
// only roles and permissions ever reach the cache.
export const PanelRoleSchema = z.object({
  id: z.string().min(1),
  // Blank is tolerated: the panel shows the id rather than an empty role.
  name: z.string(),
});

export const MeResponseSchema = z.object({
  roles: z.array(PanelRoleSchema),
  // Plain strings: an identifier the panel does not know must parse, and then grants nothing. An
  // array, never a string, because the permission check matches by inclusion.
  permissions: z.array(z.string()),
});

export type PanelRole = z.infer<typeof PanelRoleSchema>;
export type MeResponse = z.infer<typeof MeResponseSchema>;
